module.exports = __webpack_public_path__ + "img/card-provider-compensatory-services.6055c7c6.svg";